import type { DocumentResponse } from '../types';

/**
 * Visibilidade única exposta pelo produto neste momento.
 *
 * O backend continua aceitando `private`, mas o conceito saiu da UI: hoje não
 * existe autorização por documento no fluxo de leitura (o rag-service não
 * filtra resultado por visibilidade — ver ADR-049), então oferecer a escolha
 * criaria uma expectativa de proteção que o sistema não cumpre.
 *
 * Centralizado aqui para que reintroduzir a escolha seja mexer num lugar só.
 */
export const DEFAULT_VISIBILITY: DocumentResponse['visibility'] = 'public';
